import baseURL from "../common/axios";
import { value } from "dom7";
class GenericService {
  //Create API -> To Create Master
  createdata(form) {
    return baseURL.httpMSInventoryUrl.post("ItemGenericMAS/Create", form);
  }
  //Get List API -> To Show Table Values
  getlistdata() {
    return baseURL.httpMSInventoryUrl.get("ItemGenericMAS/List");
  }
  //Update API -> To Update Values in Form
  updatedata(form) {
    return baseURL.httpMSInventoryUrl.post("ItemGenericMAS/Update", form);
  }
  //Get API -> To Get Values from Table
  getdata(form) {
    return baseURL.httpMSInventoryUrl.get("ItemGenericMAS/Get?id=" + form);
  }
  //Delete -> To Delete Values from Table
  deletedata(Id) {
    return baseURL.httpMSInventoryUrl.delete(
      "ItemGenericMAS/Delete?id=" + Id
    );
  }
  active(DelID, Status) {
    debugger;
    return baseURL.httpMSInventoryUrl.put(
      "ItemGenericMAS/Active?id=" + DelID + "&Status=" + Status + ""
    );
  }
}
export default new GenericService();
